import { NgModule } from '@angular/core';
import { Routes, RouterModule, DefaultUrlSerializer, UrlTree, UrlSerializer } from '@angular/router';
import { MainComponent } from './main/main.component';
import { AuthGuard } from '@mydocma/auth';
import { SingleTabGuard } from '@mydocma/app-container';





const routes: Routes = [
  {
    path: '',
    canActivate: [SingleTabGuard],
    component: MainComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () => import('../../projects/mydocma/mm/src/lib/mm.module')
          .then(mod => mod.MmModule),
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [

  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
